import imageOne from '@/assets/images/cities/scarborough1.jpg'
import imageTwo from '@/assets/images/cities/scarborough2.jpg'
import imageThree from '@/assets/images/cities/scarborough3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Scarborough',
  writeup: '',
  website: 'MyScarboroughNotary.com',
  url: 'https://www.myscarboroughnotary.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '',
      hours: {
        monday: '1:00PM to 8:00PM',
        tuesday: '1:00PM to 8:00PM',
        wednesday: '1:00PM to 8:00PM',
        thursday: '1:00PM to 8:00PM',
        friday: '1:00PM to 8:00PM',
        saturday: '1:00PM to 8:00PM',
        sunday: '1:00PM to 8:00PM'
      },
      address: 'Markham Road Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/scarborough.js